import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-import-packages-wrapper',
  templateUrl: './simple-import-packages-wrapper.component.html',
  styleUrls: ['./simple-import-packages-wrapper.component.css']
})
export class SimpleImportPackagesWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
